<script>
  import { onMount, afterUpdate } from "svelte";
  import { writable } from "svelte/store";
  import { navigate } from "svelte-routing";

  const timers = () => {
    navigate("/timers");
  };

  let showModal = writable(false);
  let exerciseTimes = writable([]);
  let startTime = 0;
  let lastTime = 0;
  let clickCount = 0;
  let currentExerciseName = "";

  export let isGreen = false;

  let exerciseListContainer; // Reference to the exercise list container

  let exercises = [
    { name: "24 air squats", times: [] },
    { name: "16 bar-facing burpees", times: [] },
    { name: "8 shoulder-to-overheads", times: [] },
    { name: "4 thrusters", times: [] },
  ];

  function start() {
    showModal.set(true);
    startTime = Date.now();
    lastTime = startTime;
    if (clickCount === 0) {
      currentExerciseName = exercises[0].name;
    }
  }

  function formatTime(totalSeconds) {
    const horas = Math.floor(totalSeconds / 3600);
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${String(horas).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }

  function reset() {
    exercises = [
      { name: "24 air squats", times: [] },
      { name: "16 bar-facing burpees", times: [] },
      { name: "8 shoulder-to-overheads", times: [] },
      { name: "4 thrusters", times: [] },
    ];
  }

  function recordTime() {
    if (clickCount < exercises.length) {
      const currentTime = Date.now();
      const totalTime = ((currentTime - startTime) / 1000).toFixed(0);
      const intervalTime = ((currentTime - lastTime) / 1000).toFixed(0);

      exercises[clickCount].times = [totalTime, intervalTime];
      clickCount++;
      lastTime = currentTime;

      exerciseTimes.set(exercises);

      if (clickCount >= exercises.length) {
        showModal.set(false);
        clickCount = 0;
      } else {
        currentExerciseName = exercises[clickCount].name;
      }
    }
  }

  afterUpdate(() => {
    // Scroll to the bottom of the exercise list container after update
    if (exerciseListContainer) {
      exerciseListContainer.scrollTop = exerciseListContainer.scrollHeight;
    }
  });
</script>

<div class="margem">
  <div>
    <label on:click={timers}>Voltar</label>
  </div>
  <hr style="margin:5px" />
  <div>
    <strong>WOD</strong><br />
    5 rounds for time of:<br />
    <li>24 air squats</li>
    <li>16 bar-facing burpees</li>
    <li>8 shoulder-to-overheads</li>
    <li>4 thrusters</li>
  </div>
  <hr />
  <div class="buttons-container">
    <button on:click={start}>INICIAR</button><br />
    <button on:click={reset}>Reiniciar</button><br />
  </div>
  <br />

  <div class="exercise-list" bind:this={exerciseListContainer}>
    {#each exercises as exercise, index}
      <div class="bordaGeral">
        <label class="fonte" for="exercise-{index}">{exercise.name}</label>
        {#if exercise.times.length > 0}
          <label class="fonte2" for="">
            <span class="textoDaLabel">Tempo do Exercício:</span>
            <span class="valorTextoDaLabel"
              >{formatTime(exercise.times[1])}</span
            >
          </label>
          <label class="fonte2" for="">
            <span class="textoDaLabel">Tempo Total:</span>
            <span class="valorTextoDaLabel"
              >{formatTime(exercise.times[0])}</span
            >
          </label>
        {/if}
      </div>
    {/each}
  </div>

  {#if $showModal}
    <div class="modal">
      <button class="timer-button" on:click={recordTime}
        >{currentExerciseName}</button
      >
    </div>
  {/if}
</div>

<style>
  .exercise-list {
    max-height: 100%; /* Adjust height as needed */
    overflow-y: auto;
  }

  .buttons-container {
    display: flex;
    gap: 10px; /* Espaçamento entre os botões */
    margin-top: 10px; /* Espaçamento entre o label e os botões */
  }

  .bordaGeral {
    border: 2px solid #a1a1a1;
    border-radius: 5px;
    background: #f5f6fb;
    padding: 5px;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center; /* Centraliza itens horizontalmente */
    margin: 5px;
  }
  .fonte {
    font-size: 20px;
    font-weight: bold;
    color: #000080;
  }

  .fonte2 {
    font-size: 16px;
    font-weight: bold;
  }

  .textoDaLabel {
    color: rgb(71, 93, 214);
  }

  .valorTextoDaLabel {
    color: #000080;
  }

  .margem {
    margin-top: 70px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 100px;
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .timer-button {
    font-size: 2em;
    font-family: verdana;
    font-weight: bold;
    width: 80vw; /* 80% da largura da tela */
    height: 60vh; /* 60% da altura da tela */
  }

  button {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.3rem 0.7rem;
    border: none;
    border-radius: 4px;
    background-color: #1976d2;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
  }
</style>
